export default "__VITE_ASSET__y5SSXP5v__"